export default {"src":"/_next/static/media/filter_bold.54c4bf34.svg","height":24,"width":24};